<script lang="ts">
  import { ChevronDown } from "lucide-svelte"
  import { statusFilterOptions } from "$app/Pages/Plans/Goals/Filters/data"
  import { present_status } from "$app/Pages/Plans/Goals/Filters/Snippets.svelte"
  import Dropdown from "$app/components/Dropdown.svelte"

  let open = $state(true)

  interface Props {
    status: string
    onselected: (item: (typeof statusFilterOptions)[0]) => void
  }

  let { status, onselected }: Props = $props()

  let statusItem: (typeof statusFilterOptions)[0] = $derived(
    statusFilterOptions.find((g) => g.value === status)
  )
</script>

<Dropdown bind:open>
  {#snippet button()}
    <span
      class:btn-outline={open}
      class="mt-1 px-2 py-2 flex border-gray-300 rounded w-full shadow-sm border text-sm relative"
    >
      {#if statusItem}
        <div class="flex flex-row items-center whitespace-nowrap">
          {@render present_status(statusItem)}
        </div>
      {:else}
        <div class="text-sm">Not Set</div>
      {/if}
      <ChevronDown class="w-4 h-4 text-gray-400 absolute right-2 top-3" />
    </span>
  {/snippet}
  <ul class="border shadow bg-white absolute z-10 w-full">
    {#each statusFilterOptions as item}
      <li class="py-2 px-4 cursor-pointer hover:bg-gray-100 whitespace-nowrap">
        <button type="button" onclick={() => onselected(item)}>
          {@render present_status(item)}
        </button>
      </li>
    {/each}
  </ul>
</Dropdown>
